import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class NacionalidadService {
    url = environment.url2 + '/nacionalidad';
    constructor(private http: HttpClient) {}

    getAll() {
      let headers = new HttpHeaders()
      .append('Content-Type', 'application/json');
      return this.http.get(`${ this.url }/all`, { headers }).pipe( map( data => data));
    }
}
